import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { ObjectCopy } from "../ObjectCopy/ObjectCopy";

export class Schedule {

    time:string;
    vehicles:Array<Vehicle>

    constructor(time:string,vehicles:Array<Vehicle>){
        this.time = time; 
        this.vehicles = vehicles;
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/Scheduling/Schedule.ts